import { render, staticRenderFns } from "./chart.vue?vue&type=template&id=24f279f6"
import script from "./chart.ts?vue&type=script&lang=js&external"
export * from "./chart.ts?vue&type=script&lang=js&external"
import style0 from "./chart.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports